<template>
  <div class="molded-seat-base">
    <!-- Draw view -->
    <draw-view
      v-if="showDrawView"
      v-model="moldedSeat.socle_module[blobProp]"
      @on-save="saveDrawView"
      @go-back="showDrawView = false"
    />

    <v-card
      v-if="!showDrawView"
      flat
      tile
    >
      <!-- Header -->
      <v-card-actions class="justify-space-between">
        <v-btn
          text
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="onboarding"
          class="text-center"
          mandatory
        >
          <hr>
          <v-item
            v-for="n in steps"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              :input-value="active"
              icon
              @click="toggle"
            >
              {{ n }}
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          text
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- Window -->
      <v-window
        v-model="onboarding"
        touchless
      >
        <v-container>
          <!-- Step 1 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepOne :form="moldedSeat" />
          </v-window-item>

          <!-- Step 2 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepTwo :form="moldedSeat" />
          </v-window-item>

          <!-- Step 3 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepThree :form="moldedSeat" />
          </v-window-item>

          <!-- Step 4 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepFour :form="moldedSeat" />
          </v-window-item>

          <!-- Step 5 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepFive
              :form="moldedSeat"
              @sketch-click="drawView('blob')"
            />
          </v-window-item>

          <!-- Step 6 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepSix :form="moldedSeat" />
          </v-window-item>

          <!-- Step 7 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepSeven :form="moldedSeat" />
          </v-window-item>

          <!-- Step 8 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepEight :form="moldedSeat" />
          </v-window-item>

          <!-- Step 9 -->
          <v-window-item
            eager
            :reverse-transition="false"
            :transition="false"
          >
            <StepNine :form="moldedSeat" />
          </v-window-item>
        </v-container>
      </v-window>

      <!-- Buttons -->
      <div class="save-container">
        <v-btn
          class="cancel"
          @click="dialog = true"
        >
          <v-icon>mdi-close</v-icon>Annuler
        </v-btn>
        <v-btn
          class="save"
          @click="onSubmit"
        >
          <v-icon>mdi-content-save</v-icon>Enregistrer
        </v-btn>
      </div>
    </v-card>

    <!-- Confirmation dialog -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Annulation
        </v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="red"
            dark
            text
            @click="$router.go(-1)"
          >
            Oui
          </v-btn>
          <v-btn
            text
            color="black"
            @click="dialog = false"
          >
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import handleProducts from "@/mixins/handleProducts.js";

import DrawView from "../../components/DrawView";

import StepOne from "./components/StepOne.vue";
import StepTwo from "./components/StepTwo.vue";
import StepThree from "./components/StepThree.vue";
import StepFour from "./components/StepFour.vue";
import StepFive from "./components/StepFive.vue";
import StepSix from "./components/StepSix.vue";
import StepSeven from "./components/StepSeven.vue";
import StepEight from "./components/StepEight.vue";
import StepNine from "./components/StepNine.vue";

export default {
  name: "MoldedSeatBase",

  provide() {
    return { parentValidator: this.$validator };
  },

  components: {
    DrawView,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix,
    StepSeven,
    StepEight,
    StepNine
  },
  mixins: [handleProducts],

  props: {
    projectUuid: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      // How many steps for this product
      steps: 9,
      onboarding: 0,
      dialog: false,

      showDrawView: false,
      blobProp: null,

      moldedSeat: JSON.parse(
        JSON.stringify(this.$store.state.moldedSeat.moldedSeat)
      )
    };
  },

  computed: {
    ...mapGetters({
      colorsXXL: "colors/getXXLType",
      colorsLIGHT: "colors/getLIGHTType",
      colorsTRANSFER: "colors/getTRANSFERType",
      colorsPALMA: "colors/getPALMAType",
      colorsSEAT: "colors/getSEATType"
    })
  },

  beforeDestroy() {
    this.$store.dispatch("moldedSeat/resetProduct");
  },

  methods: {
    // Submit product
    async onSubmit() {
      // Check if form is valid
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        if (this.errors.items.length > 0) {
          this.errors.items.map(e => {
            const notif = {
              message: e.msg,
              type: "error"
            };
            this.$store.dispatch("notifications/add", notif);
          });
          return;
        }
      }

      // Form is valid ! Save product
      this.saveProduct(this.moldedSeat, this.projectUuid, "MOLDED_SEAT");
    },

    // Draw view
    drawView(blobProp) {
      this.blobProp = blobProp;
      this.showDrawView = true;
    },

    // Hide draw view and reset blobprop
    saveDrawView() {
      this.blobProp = null;
      this.showDrawView = false;
    },

    // Next step
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    // Previous step
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    }
  }
};
</script>
